import { ContentAssetDTO } from './ContentAssetDTO';

export type ContentAssetValue = ReturnType<typeof mapContentAsset>;

export const mapContentAsset = (dto: ContentAssetDTO) => {
    return dto['content-assets'];
};
